import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {SearchButton} from '../SearchButton';
import DatePicker from '../DatePicker';
import Typeahead from '../Typeahead';
import GuestPicker from '../GuestPicker';
import './style.less';

class SearchForm extends React.Component {
    static propTypes = {
        maxNumGuests: PropTypes.number,
        query: PropTypes.string,
        onInputQuery: PropTypes.func.isRequired,
        onSubmit: PropTypes.func.isRequired,
        guests: PropTypes.shape({
            adultsCount: PropTypes.number,
            childrenCount: PropTypes.number,
            petIncluded: PropTypes.bool
        }).isRequired,
        onInputGuest: PropTypes.func.isRequired,
        onInputGuestClose: PropTypes.func.isRequired,
        onInputGuestExit: PropTypes.func,
        checkIn: PropTypes.string,
        onInputCheckIn: PropTypes.func.isRequired,
        checkOut: PropTypes.string,
        onInputCheckOut: PropTypes.func.isRequired,
        labels: PropTypes.shape({}),
        locale: PropTypes.string,
        typeaheadProps: PropTypes.shape({}),
        isLoadingSerp: PropTypes.bool,
        isTypeaheadInputFocus: PropTypes.bool,
        onBlur: PropTypes.func,
        splitDatePicker: PropTypes.bool,
        onClose: PropTypes.func,
        onOpen: PropTypes.func,
        onFocus: PropTypes.func
    };

    static defaultProps = {
        isMobile: false,
        query: 'Where do you want to go?'
    };

    render() {
        const {
            checkIn,
            checkOut,
            guests,
            query,
            isMobile,
            labels,
            locale,
            typeaheadProps,
            isLoadingSerp,
            isGuestPickerOpened,
            isDatePickerOpened,
            isTypeaheadInputFocus,
            onBlur,
            onFocus,
            onClose,
            onOpen,
            splitDatePicker,
            onInputGuestExit
        } = this.props;

        const searchFormClass = classNames('SearchForm', {
            'checkin-focus': !checkIn || checkIn && checkOut,
            'checkout-focus': checkIn && !checkOut
        });

        const datePickerLocale = locale === 'no_NO_HA' ? locale.replace(/^no/, 'nb') : locale;

        return (
            <form className={searchFormClass} onSubmit={this.props.onSubmit}>
                <Typeahead
                    onInputQuery={this.props.onInputQuery}
                    labels={labels.typeahead}
                    {...{query, locale, onBlur, onFocus, typeaheadProps, isTypeaheadInputFocus,
                        splitDatePicker}}
                />
                <DatePicker
                    onInputCheckOut={this.props.onInputCheckOut}
                    onInputCheckIn={this.props.onInputCheckIn}
                    labels={labels.datePicker}
                    isOpen={isDatePickerOpened}
                    {...{isMobile, checkIn, checkOut, locale: datePickerLocale,
                        onClose, onOpen, splitDatePicker}}
                />
                <GuestPicker
                    onInputGuest={this.props.onInputGuest}
                    onInputGuestClose={this.props.onInputGuestClose}
                    labels={labels.guests}
                    isOpen={isGuestPickerOpened}
                    {...{isMobile, guests, splitDatePicker, onInputGuestExit}}
                />
                <SearchButton className="SearchForm__button" label={labels.buttonTitle} isLoadingSerp={isLoadingSerp} />
            </form>
        );
    }
}

export default SearchForm;
